import { GROWTH_ACTIVE_MESSAGE_WA_CONTENT_ERROR, } from 'modules/application/detail/growth/GrowthSegmentEvents';
import { ActiveMessagesConstants } from '../../../../ActiveMessagesConstants';
import { VARIABLES_COUNT_ERROR, BATCH_CONTENT_ERROR_TYPES } from '../../../../models/ErrorCodes';
import ActiveMessageTemplateDisplayVariablesView from './ActiveMessageTemplateDisplayVariablesView.html';
export class ActiveMessageTemplateDisplayVariablesController {
    static $inject = ['$translate', '$scope', 'GrowthSegmentService'];
    constructor($translate, $scope, GrowthSegmentService) {
        'ngInject';
        this.$translate = $translate;
        this.$scope = $scope;
        this.GrowthSegmentService = GrowthSegmentService;
        this.errors = {};
        this.infos = {};
        this.$onChanges = (changes) => {
            if (changes.fileSummary != undefined && changes.fileSummary.previousValue != changes.fileSummary.currentValue) {
                this.fileSummary = changes.fileSummary.currentValue;
                this.setUp();
            }
        };
        this.setUp = async () => {
            this.errors = {};
            this.infos = {};
            this.setMessageTemplateTotalVariables();
            await this.checkColumnNumbers();
            if (this.messageTemplateTotalVariables > 0) {
                this.setFileSummaryColumns();
                await this.checkFileSummary();
                this.setFileSummaryVariableColumns();
            }
            const hasErrors = Object.keys(this.errors).length > 0;
            this.hasErrorsOnBatchType(hasErrors);
        };
        this.setFileSummaryColumns = () => {
            this.fileSummaryColumnsNames = this.fileSummary?.columnsNames?.split(',');
        };
        this.checkFileSummary = async () => {
            if (this.messageTemplateButtonVariables) {
                await this.checkActionButton();
            }
            if (this.messageTemplateHasMedia) {
                await this.checkMediaVariable();
            }
        };
        this.addError = (errorMsg, errorType) => {
            if (!(errorType in this.errors)) {
                this.errors[errorType] = [];
            }
            this.errors[errorType].push(errorMsg);
        };
        this.hasError = (errorType) => errorType in this.errors;
        this.checkColumnNumbers = async () => {
            const variableColumnsCount = this.fileSummary.columnsCount - 1;
            if (variableColumnsCount < this.messageTemplateTotalVariables) {
                const errorMsg = await this.$translate('activeMessages.send.content.batch.variablesCountError', {
                    messageTemplateVariablesCount: this.messageTemplateTotalVariables,
                    fileSummaryVariablesCount: variableColumnsCount,
                });
                this.errors = { ...this.errors, [BATCH_CONTENT_ERROR_TYPES.GeneralError]: [errorMsg] };
                this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_ERROR, { errorType: VARIABLES_COUNT_ERROR });
            }
            else if (variableColumnsCount > this.messageTemplateTotalVariables) {
                const informationMsg = await this.$translate('activeMessages.send.content.batch.variablesCountInformation', {
                    messageTemplateVariablesCount: this.messageTemplateTotalVariables,
                    fileSummaryVariablesCount: variableColumnsCount,
                });
                this.infos = { ...this.infos, [BATCH_CONTENT_ERROR_TYPES.Information]: [informationMsg] };
            }
        };
        this.checkActionButton = async () => {
            const errorMsg = await this.$translate('activeMessages.send.content.batch.actionButtonVariableError');
            if (this.fileSummary.hasUrl && this.fileSummaryColumnsNames?.length == 2) {
                this.errors = {
                    ...this.errors, [BATCH_CONTENT_ERROR_TYPES.ButtonVariableError]: [errorMsg],
                };
                this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_ERROR, { errorType: BATCH_CONTENT_ERROR_TYPES.ButtonVariableError });
            }
            else if (!this.fileSummary.hasUrl && this.fileSummaryColumnsNames?.length <= 1) {
                this.errors = { ...this.errors, [BATCH_CONTENT_ERROR_TYPES.ButtonVariableError]: [errorMsg] };
                this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_ERROR, { errorType: BATCH_CONTENT_ERROR_TYPES.ButtonVariableError });
            }
        };
        this.checkMediaVariable = async () => {
            if (this.messageTemplateHasMedia && !this.fileSummary.hasUrl) {
                const errorMsg = await this.$translate('activeMessages.send.content.batch.mediaVariableError');
                this.errors = { ...this.errors, [BATCH_CONTENT_ERROR_TYPES.MediaFieldError]: [errorMsg] };
                this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_ERROR, { errorType: BATCH_CONTENT_ERROR_TYPES.MediaFieldError });
            }
        };
        this.setMessageTemplateTotalVariables = () => {
            const total = this.messageTemplateHasMedia ? 1 : 0;
            this.messageTemplateTotalTextVariables = this.messageTemplateTextVariables?.length ? this.messageTemplateTextVariables?.length : 0;
            this.messageTemplateTotalButtonVariables = this.messageTemplateButtonVariables?.length ? this.messageTemplateButtonVariables?.length : 0;
            this.messageTemplateTotalVariables = total + this.messageTemplateTotalTextVariables + this.messageTemplateTotalButtonVariables;
        };
        this.getFileSummaryMediaColumn = () => {
            return this.fileSummaryColumnsNames[1];
        };
        this.getFileSummaryButtonColumn = () => {
            if (this.messageTemplateHasMedia) {
                return this.fileSummaryColumnsNames[2];
            }
            return this.fileSummaryColumnsNames[1];
        };
        this.setFileSummaryVariableColumns = () => {
            const fileColumns = this.fileSummaryColumnsNames;
            let fileColumnsNames = [];
            let textVariableIndex = 1;
            if (this.messageTemplateHasMedia) {
                textVariableIndex++;
            }
            if (this.messageTemplateTotalButtonVariables > 0) {
                textVariableIndex++;
            }
            fileColumnsNames = fileColumns.slice(textVariableIndex);
            const textVariablesToShow = [];
            this.messageTemplateTextVariables?.forEach(async (variableName, index) => {
                const textVariableTranslated = await this.$translate('activeMessages.send.content.batch.variable', { variableName });
                const columnName = fileColumnsNames[index];
                textVariablesToShow.push({ textVariableTranslated, columnName });
            });
            this.fileSummaryTextColumns = textVariablesToShow;
            this.fileSummaryMediaTextColumn = this.fileSummaryColumnsNames[1];
            this.fileSummaryActionButtonTextColumn = this.getFileSummaryButtonColumn();
        };
        const cleanSetUp = this.$scope.$on(ActiveMessagesConstants.EVENT_CONTENT_STEP_MESSAGE_TEMPLATE_CHANGE, () => {
            this.setUp();
        });
        this.$scope.$on('$destroy', () => {
            cleanSetUp();
        });
    }
}
ActiveMessageTemplateDisplayVariablesController.$inject = ['$translate', '$scope', 'GrowthSegmentService'];
export const ActiveMessageTemplateDisplayVariablesComponent = {
    template: ActiveMessageTemplateDisplayVariablesView,
    controller: ActiveMessageTemplateDisplayVariablesController,
    controllerAs: '$ctrl',
    bindings: {
        messageTemplate: '<',
        fileSummary: '<',
        messageTemplateTextVariables: '<?',
        messageTemplateButtonVariables: '<?',
        messageTemplateHasMedia: '<?',
        hasErrorsOnBatchType: '<?',
    },
};
